class FileBase extends Component {
	constructor(el) {
		super(el);
		this.input = this.$find('input');
		this.selectedContainer = this.$find('[data-selected]');
		this.noFiles = this.selectedContainer.dataset.noText;
		this.addEventListeners();
	}

	manageSelected() {
		if(!this.input.files.length) {
			this.selectedContainer.innerText = this.noFiles;
			return;
		}
		const files = Array.from(this.input.files).map(file => file.name);
		this.selectedContainer.innerText = files.join(', ');
	}

	addEventListeners() {
		this.input.addEventListener('change', () => this.manageSelected());
	}
}